import Api from '../../Components/Api';
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { ORDER_DATA, ORDER_LIST, LANDING_BANNERS, HOME_GROUPS, ALL_MENU, ITEM_DETAIL, COMBO_DETAIL, TOP_DEALS, BEST_SELLERS, CROSS_SELL, ORDER_DETAIL, LAST_FIVE_ORDERS, WEB_APP_THEME } from "./menuTypes"
import jwtDecode from "jwt-decode";
import { getProfile } from './customer';
import { DONATION_DATA } from './cartTypes';
import { getLocale } from '../../lib';
var CryptoJS = require("crypto-js");

export const ordersList = () => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem("userToken");
    if (token) {
      let decoded: any
      decoded = token ? jwtDecode(token) : null
      Api.get(`/customer/orders/${decoded.customer && decoded.customer.customer_id}`, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((response) => {
          if (response.data.success) {
            dispatch({
              type: ORDER_LIST,
              payload: response.data.successResponse,
            });
          }
        })
        .catch((err) => {
        });
    }
  };
};
export const orderDetail = (order_id: any, setState?: any, feedback?: any) => {
  return async (dispatch: any) => {

    let token: any = await localStorage.getItem('userToken');
    if (token) {
      Api.get(`/customer/order/${order_id}`, {
        headers: { Authorization: 'Bearer ' + token, locale: getLocale() },
      })
        .then((response) => {
          if (response.data.success) {
            dispatch({
              type: ORDER_DETAIL,
              payload: response.data.successResponse,
              loading: false
            });
            if (feedback) {
              dispatch(getProfile(response?.data?.successResponse?.order?.customer_id))
            }
            setTimeout(() => {
              setState(true);
            }, 100);


          }
        })
        .catch((err) => {
        });
    }
  };
};
export const trackOrder = (data: any, locale: string) => {
  var encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.REACT_APP_EncryptionKey
  ).toString();
  return function (dispatch: any) {
    Api.post(
      `customer/trackOrder`,
      { body: encryptedData },
      {
        headers: {
          locale,
        },
      }
    )
      .then((response) => {
        if (response.data.success) {
          let responseData = response.data.successResponse;
          dispatch({
            type: ORDER_DATA,
            payload: responseData,
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          dispatch({
            type: ORDER_DATA,
            trackOrderData: {},
          });
          toast.error(
            error,
            {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000,
            }
          );
        }
      });
  };
};
export const storeMenuItemCall = (store_id: any, orderType: any, pathname: string, locale?: string) => {
  return function (dispatch: any) {
    let data: any = {
      mode: "online",
      channel: orderType,
      store_id: store_id
    }
    if (pathname == `/${locale}/menu`) {
      dispatch(getAllMenu(store_id, orderType))
    } else if (pathname == `/${locale}/bucket`) {
      dispatch(getCrossSellItems(data))
    } else if (pathname == `/${locale}`) {
      let bannerBody: any = {
        banner_type: "landing",
        channel: orderType,
        store_id: store_id
      }
      dispatch(getGroups(data));
      dispatch(getBestSellers(data))
      dispatch(getTopDeals(data))
      dispatch(getLandingBanners(bannerBody))
    }
  }
}
export const getLandingBanners = (data: any) => {
  var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
  return async (dispatch: any) => {
    Api.post('menu/banners', { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: LANDING_BANNERS,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === 'string') {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === 'object') {
            error = err.response.data.message[0].replace(/_/g, ' ');
          }
          dispatch({
            type: LANDING_BANNERS,
            payload: [],
          });
        } else {
        }
      });
  };
};
export const getDonationsData = () => {
  return async (dispatch: any) => {
    Api.get('menu/donations')
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: DONATION_DATA,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: DONATION_DATA,
          payload: [],
        });
      });
  };
};
export const getGroups = (data: any) => {
  var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
  return async (dispatch: any) => {
    Api.post('menu/groups', { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: HOME_GROUPS,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === 'string') {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === 'object') {
            error = err.response.data.message[0].replace(/_/g, ' ');
          }
          dispatch({
            type: HOME_GROUPS,
            payload: [],
          });
        } else {
        }
      });
  };
}
export const getTopDeals = (data: any) => {
  return async (dispatch: any) => {
    const token: any = await localStorage.getItem('userToken');
    if (token) {
      var decoded: any = jwtDecode(token);
      data.customer_id = decoded.customer.customer_id;
    }
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    dispatch({
      type: TOP_DEALS,
      payload: null
    });
    Api.post('menu/top4Deals', { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: TOP_DEALS,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === 'string') {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === 'object') {
            error = err.response.data.message[0].replace(/_/g, ' ');
          }
          dispatch({
            type: TOP_DEALS,
            payload: [],
          });
        } else {
        }
      });
  };
}
export const getBestSellers = (data: any) => {
  var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
  return async (dispatch: any) => {
    Api.post('menu/bestSellers', { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: BEST_SELLERS,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === 'string') {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === 'object') {
            error = err.response.data.message[0].replace(/_/g, ' ');
          }
          dispatch({
            type: BEST_SELLERS,
            payload: [],
          });
        }
      });
  };
}

export const getAllMenu = (store_id: any, orderType: any, fav?: any) => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem('userToken');
    let data: any = {
      mode: 'online',
      channel: orderType
    };
    if (store_id) {
      data.store_id = store_id
    }
    else {
      data.store_id = null
    }

    if (token) {
      var decoded: any = jwtDecode(token);
      data.customer_id = decoded.customer.customer_id;
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`menu/allGroups`, { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: ALL_MENU,
            groups: response.data.groups,
            groupsData: response.data.groupsData
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          dispatch({
            type: ALL_MENU,
            groups: [],
            groupsData: []
          });
        }
      });
  };
};
export const getComboDetail = (orderType: any, id: any, handleComboOpen?: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: COMBO_DETAIL,
      payload: {},
    });
    dispatch({
      type: ITEM_DETAIL,
      payload: {}
    });
    let channel = orderType;
    let obj: any = {
      mode: 'online'
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`menu/combo/${id}`, { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          let comboData = response.data.successResponse;
          if (channel) {
            if (channel == "Delivery") {
              if (comboData.combo_channel_id == 1 || comboData.combo_channel_id == 5) {
                dispatch({
                  type: COMBO_DETAIL,
                  payload: response.data.successResponse,
                });
                handleComboOpen && handleComboOpen()
              } else {
                toast.info("Product available for only Pickup", {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            } else if (channel == "Pickup") {
              if (comboData.combo_channel_id == 2 || comboData.combo_channel_id == 5) {
                dispatch({
                  type: COMBO_DETAIL,
                  payload: response.data.successResponse,
                });
                handleComboOpen && handleComboOpen()
              } else {
                toast.info("Product available for only Delivery", {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            }
          } else {
            if (comboData.combo_channel_id == 5) {
              dispatch({
                type: COMBO_DETAIL,
                payload: response.data.successResponse,
              });
              handleComboOpen && handleComboOpen()
            } else {
              toast.info("Product not available", {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          dispatch({
            type: COMBO_DETAIL,
            payload: {},
          });
        }
      });
  };
};

export const changeTheme = (theme: any) => {
  return {
    type: WEB_APP_THEME,
    payload: theme
  }
}

export const getItemDetail = (orderType: any, item_id: any, handleShow?: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: ITEM_DETAIL,
      payload: {},
    });
    dispatch({
      type: COMBO_DETAIL,
      payload: {},
    });
    let channel = orderType;
    let obj: any = {
      mode: 'online'
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`menu/item/${item_id}`, { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          let itemData = response.data.successResponse;
          if (channel) {
            if (channel == "Delivery") {
              if (itemData.item_channel_id == 1 || itemData.item_channel_id == 5) {
                dispatch({
                  type: ITEM_DETAIL,
                  payload: response.data.successResponse,
                });
                handleShow && handleShow()
              } else {
                toast.info("Product available for only Pickup", {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            } else if (channel == "Pickup") {
              if (itemData.item_channel_id == 2 || itemData.item_channel_id == 5) {
                dispatch({
                  type: ITEM_DETAIL,
                  payload: response.data.successResponse,
                });
                handleShow && handleShow()
              } else {
                toast.info("Product available for only Delivery", {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            }
          } else {
            if (itemData.item_channel_id == 5) {
              dispatch({
                type: ITEM_DETAIL,
                payload: response.data.successResponse,
              });
              handleShow && handleShow()
            } else {
              toast.info("Product not available", {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          dispatch({
            type: ITEM_DETAIL,
            payload: {},
          });
        } else {
        }
      });
  };
};

export const getCrossSellItems = (data: any) => {
  var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
  return async (dispatch: any) => {
    Api.post('menu/cross_sell_items', { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: CROSS_SELL,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === 'string') {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === 'object') {
            error = err.response.data.message[0].replace(/_/g, ' ');
          }
          dispatch({
            type: CROSS_SELL,
            payload: [],
          });
        }
      });
  };
}

export const lastFiveOrders = (setShow: any, history: any) => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem("userToken");
    let decoded: any
    decoded = token ? jwtDecode(token) : null
    Api.get(`/last_five_orders/${decoded?.customer && decoded?.customer?.customer_id}`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: LAST_FIVE_ORDERS,
            payload: response.data.successResponse
          })
          setShow(true)
        }
      })
      .catch((err) => {
        history.push("/order-history")
        dispatch({
          type: LAST_FIVE_ORDERS,
          payload: []
        })
      });
  };
};